<template>
  <SectionCard
    :title="getTitle"
    data-aos="fade-in"
  >
    <ul>
      <li>
        •
        <a
          :href="$t('link.index1.l4')"
          target="_blank"
        >
          {{ $t("home.s7.notice.t1") }}
        </a>
      </li>
      <li>
        •
        <a
          :href="$t('link.index1.l5')"
          target="_blank"
        >
          {{ $t("home.s7.notice.t2") }}
        </a>
      </li>
      <li>
        •
        <a
          :href="$t('link.index1.l6')"
          target="_blank"
        >
          {{ $t("home.s7.notice.t3") }}
        </a>
      </li>
    </ul>
    <div class="btndiv">
      <!-- <Buttonrouter to="#">
        查看全部
      </Buttonrouter> -->
      <myButton
        href="https://lambdastorage.zendesk.com/hc/en-001"
        custom-type="link"
      >
        {{ $t("home.s7.notice.btn") }}
      </myButton>
    </div>
  </SectionCard>
</template>

<script>
export default {
  components: {
    SectionCard: () => import("@/components/SectionCard.vue"),
    myButton: () => import("@/components/MyButton.vue")
  },
  computed: {
    getTitle () {
      return this.$t("home.s7.notice.title");
    }
  }
};
</script>
<style lang="less" scoped>
@media (max-width: 500px) {
  ul {
    width: 100%;
    list-style: none;
    color: #e02053;
    padding-inline-start: 0px;
    li {
      width: 96%;
      float: left;
      line-height: 25px;
      font-size: 16px;
      // padding: 12px 0px;
      border-bottom: 1px dashed #c4c4c4;
      padding-bottom: 25px;
      padding-top: 31px;
    }
  }
}

@media (min-width: 501px) {
  ul {
    width: 100%;
    list-style: none;
    color: #e02053;
    padding-inline-start: 0px;
    li {
      width: 46%;
      float: left;
      line-height: 25px;
      font-size: 16px;
      // padding: 12px 0px;
      border-bottom: 1px dashed #c4c4c4;
      padding-bottom: 25px;
      padding-top: 31px;
    }
    li:nth-child(2n) {
      margin-left: 3%;
    }
    li:nth-child(2n-1) {
      margin-right: 3%;
    }
  }
}

.btndiv {
  width: 100%;
  text-align: center;
  margin-top: 46px;
}
</style>
